<template>
  <v-layout row>
    <v-flex xs12>
      <v-card>
        <v-list two-line>
          <template v-for="(item, index) in items">
            <v-list-tile
              :key="item.id"
              avatar
              @click="getPost(item.id)"
            >
              <v-list-tile-avatar>
                <img :src="item.avatar">
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title v-html="item.username"></v-list-tile-title>
                <v-list-tile-sub-title v-html="item.story"></v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-badge
                  overlap
                  color="blue"
                >
                  <span slot="badge">{{ item.points }}</span>
                  <v-icon
                    large
                    color="yellow darken-2"
                  >
                    star
                  </v-icon>
                </v-badge>
              </v-list-tile-action>
            </v-list-tile>
            <v-divider v-if="index + 1 < items.length" :key="`divider-${index}`"></v-divider>
          </template>
        </v-list>
        <v-snackbar
          v-model="snackbar"
          :color="error"
          :timeout="10000"
          :top="true"
        >
          {{ error }}
          <v-btn
            dark
            flat
            @click="snackbar = false"
          >
            Close
          </v-btn>
        </v-snackbar>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  export default {
    props: ['challenge'],
    data () {
      return {
        snackbar: false,
        error: "",
        posts: [],
        items: []
      }
    },
    methods: {
      getPost (id) {
        this.$router.push({
          name: 'postDetails',
          query: {
            id: id
          }
        });
      },
      populateItems () {
        this.posts.map((post, idx) => {
          let item = {
            id: post.id,
            username: post.user.username,
            avatar: post.user.avatar ? post.user.avatar : 'img/avatar.png',
            story: post.story,
            media: [],
            points: post.points
          };

          post.media.map((media) => {
            const type = media.mime.split('/')[0];

            if (type != 'image' && type != 'video') {
              return;
            }
            
            item.media.push({
              id: media.id,
              type: type,
              mimeType: media.mime,
              url: media.url
            });
          });

          this.items.push(item);
        });
      }
    },
    created () {
      this.$http.api.checkLogin();
    },
    mounted () {
      const url = `/posts/challenge/${this.challenge}`;

      this.$http.api.get(url)
      .then(response => {
        this.posts = response.data;

        this.populateItems();
      })
      .catch(error => {
        if (error.response) {
          this.error = this.$http.api.getError(error).toString;
          this.snackbar = true;
        }
        else {
          console.dir(error);
        }
      });
    }
  }
</script>